<template>
  <div>
    <vs-row>
      <vs-col vs-w="6">
        <h3 style="margin-bottom: 20px">Personas</h3>
      </vs-col>
      <vs-col vs-w="6" style="text-align: right">
        <vs-button @click="abrir_modal_nuevo" size="small">Nuevo</vs-button>
      </vs-col>
    </vs-row>
    <div class="vx-row" v-if="personas.length == 0 && !iniciando">
      <vs-alert title="Debes dar de alta personas" color="danger" active="true">
        Antes de inscribirte tú o a tus familiares a cualquier actividad
        <a style="cursor: pointer" @click="$router.push({ path: 'hijos' })"
          >da de alta una nueva persona</a
        >
        ¡Inclúyete a ti mismo también como persona!
        <br />
        <br />
        <vs-button
          color="danger"
          @click="
            popupActive2 = true;
            mensaje_formulario = 'Añadir persona';
            menor_id = 0;
          "
          type="filled"
          >Dar de alta una nueva persona</vs-button
        >
        <br />
      </vs-alert>
    </div>
    <vs-row v-if="hijos.length > 0">
      <vs-col
        style="margin-bottom: 10px"
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="4"
        vs-sm="6"
        vs-xs="12"
        v-for="hijo in hijos"
        :key="hijo.id"
      >
        <vs-card style="margin: 5px; width: calc(100% - 10px)">
          <div slot="header">
            <vs-avatar />
            <h3
              style="
                vertical-align: top;
                display: inline-block;
                line-height: 43px;
                margin-left: 10px;
              "
            >
              {{ hijo.nombre }} {{ hijo.apellidos }}
            </h3>
          </div>
          <div>
            <p>Fecha de nacimiento: {{ fecha_bonita(hijo.fechaNacimiento) }}</p>
            <p>Colegio: {{ hijo.colegio }}</p>
            <p>Teléfono: {{ hijo.telefono }}</p>
            <p>Alergias: {{ hijo.alergias }}</p>
            <p>
              Abonado: <span v-if="hijo.abonado">Sí</span><span v-else>No</span>
            </p>
            <div
              v-if="
                typeof hijo.actividades !== 'undefined' &&
                hijo.actividades.length > 0
              "
            >
              <h5>Actividades</h5>
              <div v-for="actividad in hijo.actividades" :key="actividad.id">
                <strong>{{ actividad.nodo.titulo }}</strong>
              </div>
            </div>
          </div>
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button
                color="warning"
                icon="edit"
                @click="edit_hijo(hijo.id)"
                style="margin-right: 10px"
              ></vs-button>
              <vs-button
                color="danger"
                icon="close"
                @click="delete_hijo(hijo.id)"
              ></vs-button>
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>

    <vs-popup
      classContent="popup-example"
      :title="mensaje_formulario"
      :active.sync="popupActive2"
      style="min-height: 400px"
    >
      <vs-input type="hidden" v-model="menor_id" />
      <vs-input label="Nombre" placeholder="Nombre" v-model="nombre" />
      <vs-input label="Apellidos" placeholder="Apellidos" v-model="apellidos" />
      <!-- <label for="" class="vs-input--label"
        >Fecha de nacimiento dd-mm-yyyy</label
      > -->
      <!-- <datepicker
        v-model="fechaNacimiento"
        :monday-first="true"
        :language="es"
        name="fechaNacimiento"
        :calendar-button="true"
        calendar-button-icon="fa fa-calendar"
        placeholder="mm-dd-yyyy"
        style="max-width: 200px; margin-bottom: 10px"
        @selected="selected"
      ></datepicker> -->
      <vs-input
        v-model="fechaNacimiento"
        label="Fecha de Nacimiento (dd/mm/yyyy)"
        placeholder="Fecha de Nacimiento (dd/mm/yyyy)"
        type="date"
      />
      <vs-input label="Colegio" placeholder="Colegio" v-model="colegio" />
      <vs-input label="Teléfono" placeholder="Teléfono" v-model="telefono" />
      <vs-checkbox v-model="abonado">Abonado</vs-checkbox>
      <vs-textarea
        style="margin-top: 15px"
        label="Alergias"
        v-model="alergias"
      />

      <vs-button
        @click="new_hijo"
        color="primary"
        type="filled"
        v-if="menor_id == 0"
        >Añadir</vs-button
      >
      <vs-button @click="save_hijo" color="primary" type="filled" v-else
        >Guardar</vs-button
      >

      <vs-popup title="Inner popup" :active.sync="popupActive3">
        <p>Añade un nuevo hijo</p>
      </vs-popup>
    </vs-popup>
  </div>
</template>

<script>
//import JQuery from 'jquery'
//let $ = JQuery
import vSelect from "vue-select";
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import { en, es } from "vuejs-datepicker/dist/locale";

export default {
  data() {
    return {
      hijos: [],
      popupActive2: false,
      popupActive3: false,
      menor_id: 0,
      nombre: "",
      apellidos: "",
      fechaNacimiento: "",
      colegio: "",
      telefono: "",
      abonado: false,
      alergias: "",
      mensaje_formulario: "Añadir persona",
      iniciando: true,
      es: es,
      en: en,
    };
  },
  computed: {
    ...mapGetters(["carrito", "personas"]),
  },
  mounted() {
    //Primero de todo obtenemos los hijos que tenga este gacho.
    this.get_hijos();
  },
  methods: {
    abrir_modal_nuevo() {
      this.popupActive2 = false;
      this.nombre = "";
      this.apellidos = "";
      this.fechaNacimiento = "";
      this.colegio = "";
      this.telefono = "";
      this.alergias = "";
      this.popupActive2 = true;
      this.mensaje_formulario = "Añadir persona";
      this.menor_id = 0;
    },
    fecha_bonita(fecha) {
      if (fecha == "" || fecha === null) return fecha;
      else return fecha.split("-").reverse().join("/");
    },
    get_hijos() {
      this.$store.dispatch("get_hijos").then((data) => {
        if (typeof data !== "undefined") this.hijos = data;

        this.iniciando = false;
      });
    },
    new_hijo() {
      this.fechaNacimiento = this.$moment(this.fechaNacimiento).format(
        "YYYY-MM-DD"
      );
      this.$store
        .dispatch("new_hijo", {
          nombre: this.nombre,
          apellidos: this.apellidos,
          fechaNacimiento: this.fechaNacimiento,
          colegio: this.colegio,
          telefono: this.telefono,
          alergias: this.alergias,
          abonado: this.abonado,
        })
        .then((message) => {
          this.get_hijos();
          this.$vs.notify({
            title: "Éxito",
            text: message,
            iconPack: "feather",
            icon: "icon-thumbs-up",
            color: "success",
          });
          this.popupActive2 = false;
          this.nombre = "";
          this.apellidos = "";
          this.fechaNacimiento = "";
          this.colegio = "";
          this.telefono = "";
          this.alergias = "";
        })
        .catch((message) => {
          this.$vs.notify({
            title: "Error",
            text:
              "Los siguientes campos son necesarios: " +
              Object.keys(message.data.errors),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    save_hijo() {
      this.fechaNacimiento = this.$moment(this.fechaNacimiento).format(
        "YYYY-MM-DD"
      );
      this.$store
        .dispatch("save_hijo", {
          menor_id: this.menor_id,
          nombre: this.nombre,
          apellidos: this.apellidos,
          fechaNacimiento: this.fechaNacimiento,
          colegio: this.colegio,
          telefono: this.telefono,
          alergias: this.alergias,
          abonado: this.abonado,
        })
        .then((message) => {
          this.get_hijos();
          this.$vs.notify({
            title: "Éxito",
            text: message,
            iconPack: "feather",
            icon: "icon-thumbs-up",
            color: "success",
          });
          this.$store.commit("actualizar_carrito_hijo", {
            menor_id: this.menor_id,
            nombre: this.nombre,
            apellidos: this.apellidos,
            fechaNacimiento: this.fechaNacimiento,
            colegio: this.colegio,
            telefono: this.telefono,
            alergias: this.alergias,
            abonado: this.abonado,
          });
          this.popupActive2 = false;
          this.nombre = "";
          this.apellidos = "";
          this.fechaNacimiento = "";
          this.colegio = "";
          this.telefono = "";
          this.alergias = "";
          /*
        this.carrito.forEach((reserva_nodo,index) => {
          if(reserva_nodo.cantidad > 0 && reserva_nodo.reserva.estado == -1){
            reserva_nodo.index = index
            carrito_actual.push(reserva_nodo)
          }
        })*/
        })
        .catch((message) => {
          this.$vs.notify({
            title: "Error",
            text:
              "Los siguientes campos son necesarios: " +
              Object.keys(message.data.errors),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    edit_hijo(id) {
      this.menor_id = id;
      this.popupActive2 = true;
      this.hijos.forEach((hijo) => {
        if (hijo.id == id) {
          this.mensaje_formulario = "Editar persona";
          this.menor_id = id;
          this.nombre = hijo.nombre;
          this.apellidos = hijo.apellidos;
          this.fechaNacimiento = hijo.fechaNacimiento;
          this.colegio = hijo.colegio;
          this.telefono = hijo.telefono;
          this.abonado = hijo.abonado;
          this.alergias = hijo.alergias;
        }
      });
    },
    delete_hijo(id) {
      if (confirm("¿Estás seguro que quieres eliminar este hijo?")) {
        this.$store
          .dispatch("delete_hijo", {
            id: id,
          })
          .then((message) => {
            this.get_hijos();
            this.$vs.notify({
              title: "Éxito",
              text: message,
              iconPack: "feather",
              icon: "icon-thumbs-up",
              color: "success",
            });
          })
          .catch((message) => {
            this.$vs.notify({
              title: "Error",
              text: message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });
      }
    },
  },
  components: {
    "v-select": vSelect,
    Datepicker,
  },
};
</script>
